export default {
  ws: 'ws://advolt.voltdigital.com.br:5066',
  wss: 'wss://advolt.voltdigital.com.br:7443',
  userAgent: {
    aor: 'sip:1000@advolt.voltdigital.com.br',
    username: '1000',
    password: '97ce20b9e5148d78ad424c0d00fc26b1',
  },
}
